import { Box } from '@wix/design-system';
import React from 'react';
export const ProductCardTag = ({ children, marginTop, marginBottom, height, isVisible, }) => {
    return (React.createElement(Box, { width: "100%", align: "center", marginTop: marginTop, marginBottom: marginBottom, visibility: isVisible ? 'visible' : 'hidden', height: height }, isVisible && children));
};
//# sourceMappingURL=ProductCardTag.js.map